import config from '@/config';
import Script from 'next/script';
import { memo } from 'react';
import type { GTMConfig } from './types';

const GTM_ID = process.env.GOOGLE_TAG_MANAGER_ID;

const GTM_CONFIGS: Record<string, GTMConfig> = {
  enercity: {
    baseUrl: 'https://tm.aws-prod.enercity.de',
    withCMP: false,
  },
  default: {
    baseUrl: 'https://www.googletagmanager.com',
    withCMP: true,
  },
};

/**
 * Determines if GTM should be loaded based on configuration
 * Ref: https://enerdigi.enercity.de/wiki/pages/viewpage.action?pageId=142020250
 */
const shouldLoadGTM = Boolean(config.consentManagerId || GTM_ID);

const gtmConfig = GTM_CONFIGS[config.currentProjectName] ?? GTM_CONFIGS.default;

const scriptAttributes = gtmConfig.withCMP
  ? {
      className: 'cmplazyload',
      'data-cmp-vendor': 's905',
      type: 'text/plain',
    }
  : {};

const GoogleTagManagerScript = memo(() => {
  if (!shouldLoadGTM) {
    return null;
  }

  return (
    <>
      <Script
        id="google-tag-manager-script"
        strategy="lazyOnload"
        {...scriptAttributes}
        dangerouslySetInnerHTML={{
          __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          '${gtmConfig.baseUrl}/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','${GTM_ID}');`,
        }}
      />
      <noscript>
        <iframe
          src={`${gtmConfig.baseUrl}/ns.html?id=${GTM_ID}`}
          height="0"
          width="0"
          style={{ display: 'none', visibility: 'hidden' }}
          title="Google Tag Manager"
        />
      </noscript>
    </>
  );
});

GoogleTagManagerScript.displayName = 'GoogleTagManagerScript';

export default GoogleTagManagerScript;
